import React from 'react';
import './App.css';
import { PendulumDisplay } from './pendulum';

function App() {
  return (
    <div className="App">
	  <PendulumDisplay width={500} height={500} as={[0, 0, 0, 0]} ls={[100, 100, 100, 100]} />
    </div>
  );
}

export default App;
